export default "__VITE_ASSET__BcN7Pl6K__"